import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { AuthForm } from '../model/auth.model';

@Injectable({
  providedIn: 'root',
})
export class KeycloakService {
  constructor(private readonly _httpClient: HttpClient) {}

  auth(authForm: AuthForm): Observable<any> {
    return this._httpClient.post<any>(
      `${environment.auth.basePathIam}${environment.auth.renewAppToken}?clientId=${environment.clientId}&remember-me=${environment.auth.rememberUser}`,
      authForm
    );
  }

}
